import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';

class Loading extends Component {

  

  render() {
    return (
        <main className="page__container" style={{ paddingTop: 30 }}>
            <Skeleton height={200} count={5}/>
        </main>
    );
  }

}

export default Loading;
